<div class="table-container" [style.grid-template-columns]="gridColumns">
  <div i18n class="super header">Gesamtbewertung</div>
  <div i18n class="super header seperator-border" [style.grid-column]="'span {{ members.length }}'">Individuelle Bewertungen</div>
  <div i18n class="header left-align">Alternative</div>
  <div i18n class="header">Gewichteter<br />Gesamtnutzen</div>
  @for (member of team.members; track member; let first = $first) {
  <div i18n class="header" [class.seperator-border]="first">
    <dt-team-member-name [member]="member"></dt-team-member-name>
  </div>
  } @for (alternative of teamCalc.aggregatedProject.alternatives; track alternative; let alternativeIndex = $index) {
  <div class="left-align" [style.grid-row]="3 + alternativeRanking[alternativeIndex]">
    <span class="alternative-rank">{{alternativeRanking[alternativeIndex] + 1}}.</span>{{alternative.name}}
  </div>
  <div [style.grid-row]="3 + alternativeRanking[alternativeIndex]">
    {{aggregatedUtilityValues[alternativeIndex] * 100 | number: '1.0-2'}}
  </div>
  @for (member of team.members; track member; let first = $first; let memberIndex = $index) {
  <div
    class="rank-cell"
    [style.grid-row]="3 + alternativeRanking[alternativeIndex]"
    [class.for]="member.alternativeOpinions?.[alternative.uuid]?.sentiment === true"
    [class.against]="member.alternativeOpinions?.[alternative.uuid]?.sentiment === false"
    [class.seperator-border]="first"
    [dtHoverPopover]="member.alternativeOpinions?.[alternative.uuid]?.sentiment != null && member.alternativeOpinions[alternative.uuid].comment ? opinion: null"
  >
    @if (memberUtilityValues[memberIndex][alternativeIndex] !== -1) {
    <div i18n>{{memberAlternativeRanking[memberIndex][alternativeIndex]}}. Platz</div>
    <div
      >{{memberUtilityValues[memberIndex][alternativeIndex] * 100 | number: '1.0-2'}}@if (memberBestAlternativeUtility[memberIndex] !==
      memberUtilityValues[memberIndex][alternativeIndex]) {
      <span>
        (-{{(memberBestAlternativeUtility[memberIndex] - memberUtilityValues[memberIndex][alternativeIndex]) * 100 | number:
        '1.0-2'}})</span
      >
      }</div
    >
    } @else{
    <div> - </div>
    }
  </div>
  <ng-template #opinion>
    <div
      class="opinion"
      [class.for]="member.alternativeOpinions?.[alternative.uuid].sentiment"
      [class.against]="!member.alternativeOpinions?.[alternative.uuid].sentiment"
    >
      {{member.alternativeOpinions[alternative.uuid].comment}}
    </div>
  </ng-template>
  } }
</div>
